export class UserModel {
    CompanyId : number;
    EmpCode : number;
    UserName : string;
    Password : string;
    UserType : string;
    RoleId : number;
    BranchCode : string;
    IEMINO : string;
    OTP : string;
    OTPDate : Date; 
    IPAddressL : string;
    MacAddressL : string;
    IUser : string;
    Name : string;
    Email : string;

}

// export class  UserManagement extends BaseModel  {
    


// }

export class RequestModel
{
    EncryptString : string;

}


export class UsersModel
{


}